import { clsx } from 'clsx';

import cls from './ProductRemainder.module.scss';

type ProductRemainder = {
  remainder: string | undefined;
  className?: string;
};

export const ProductRemainder = ({ remainder, className }: ProductRemainder) => {
  const inStock = remainder !== undefined && +remainder !== 0;
  const text = !inStock ? 'Нет в наличии' : +remainder < 6 ? 'Осталось мало' : 'На складе много';

  return (
    <div className={clsx(cls.wrap, className, { [cls.stock]: inStock && +remainder > 0, [cls.not]: !inStock })}>
      <div className={cls.circle}>
        <div className={cls.icon} />
      </div>
      <div className={cls.text}>{text}</div>
    </div>
  );
};
